import { CommonModule, NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
  IonButton,
  IonCard,
  IonCol,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonRow,
  IonSegment,
  IonSegmentButton,
} from '@ionic/angular/standalone';
import { SharedModule } from '../shared/shared.module';
import { NoResultComponent } from './package-tracking-popup/no-result/no-result.component';
import { PackageHistoryEventComponent } from './package-tracking-popup/package-history/package-history-event/package-history-event.component';
import { PackageHistoryComponent } from './package-tracking-popup/package-history/package-history.component';
import { PackageInquiryComponent } from './package-tracking-popup/package-inquiry/package-inquiry.component';
import { PackageTrackingPopupComponent } from './package-tracking-popup/package-tracking-popup.component';

@NgModule({
  declarations: [
    PackageTrackingPopupComponent,
    PackageHistoryComponent,
    PackageHistoryEventComponent,
  ],
  imports: [
    NgClass,
    NoResultComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonCol,
    IonLabel,
    IonSegmentButton,
    IonCard,
    IonRow,
    IonIcon,
    IonButton,
    IonInput,
    IonItem,
    IonSegment,
    SharedModule,
    PackageInquiryComponent,
  ],
})
export class PackageModule {}
